import { Form, SchemaFormHook } from "@/components/form";
import { Dialog, DialogProps, ModalHeader } from "@/components/modal";
import { usePrinter } from "@/components/print";
import { ReactNode } from "react";
import { z } from "zod/v4";

const printFormSchema = z.object({
    title: z.string().nonempty("Este campo es requerido"),
    description: z.string()
})

interface PrintExportDialogProps extends DialogProps {
    dialogTitle?: string,
    defaultFileTitle: string,
    printComponent: ReactNode | Promise<ReactNode> | ((formData: z.infer<typeof printFormSchema>) => ReactNode | Promise<ReactNode>)
}

export default function PrintExportDialog({
    defaultFileTitle,
    dialogTitle = "Imprimir",
    printComponent,
    ...props
}: PrintExportDialogProps) {
    const printer = usePrinter();

    return <Dialog size="sm" {...props}>
        <ModalHeader>{dialogTitle}</ModalHeader>
        <SchemaFormHook
            schema={printFormSchema}
            onSubmit={async ({ value }) => {
                const component = typeof printComponent === "function" ?
                    await printComponent(value) :
                    await printComponent

                await printer.print({
                    documentTitle: value.title,
                    printComponent: component
                })
            }}
            defaultValues={{
                title: defaultFileTitle,
                description: ""
            }}
            submitOnce
            closeModalOnSubmit
        >
            {printForm => <Form form={printForm} padding={3} gap={3}>
                <Form.TextField name="title" label="Título" />
                <Form.TextField name="description" label="Descripción" multiline rows={5} />
                <Form.SubmitButton>Exportar</Form.SubmitButton>
            </Form>}
        </SchemaFormHook>
        <printer.Printer />
    </Dialog>
}